import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../../shared/services/util.service";
import {configuracaoModuleName, editRoute, newRoute} from "../../../../shared/services/data.service";
import { ObrigacaoTipoApiService } from "../shared/obrigacao-tipo-api.service";
import { ObrigacaoTipoNavigationService } from "../shared/obrigacao-tipo-navigation.service";
import { AutoCompleteService } from "../../../../shared/components/autocomplete/autocomplete.service";
import { TipoObrigacao } from "../shared/obrigacao-tipo.model";
import { ObrigacaoTipoService } from "../shared/obrigacao-tipo.service";
import { obrigacaoTiposStorage, obrigacaoTiposModuleName } from "../shared/data.service";
import { obrigacoesModuleName } from "../../shared/data.service";
import { DespachoService } from "../../../shared/despacho.service";

@Component({
    template: require('./obrigacao-tipo-form.component.html'),
    styles: [require('./obrigacao-tipo-form.component.css')]
})
export class ObrigacaoTipoFormComponent implements OnInit {
    obrigacaoTiposModule:any = obrigacaoTiposModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = obrigacoesModuleName;
    formObject:any = new TipoObrigacao();
    actionTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;

    form:FormGroup;
    ativo = new FormControl('');
    titulo = new FormControl('', Validators.required);
    descricao = new FormControl('');

    private returnToOtherForm:boolean = false;
    private otherForm:string;
    private responseTipoObrigacao:any;

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _obrigacaoTipoApiService: ObrigacaoTipoApiService,
        private _obrigacaoTipoNavigationService: ObrigacaoTipoNavigationService,
        private _obrigacaoTipoService: ObrigacaoTipoService,
        private _autocompleteService:AutoCompleteService,
        private _despachoService: DespachoService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            descricao: this.descricao,
            titulo: this.titulo
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickGoToConfig() {
        this._despachoService.goToSettingObrigacoes();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:TipoObrigacao = this._utilService.cloneObject(this.formObject);


            if (this.formObject.id) {
                this.onEdit(object);
            } else {
                this.onAdd(object);
            }
        }
    }

    private onAdd(object: TipoObrigacao) {
        this._obrigacaoTipoApiService.onPost(object, this.onDone);
    }

    private onEdit(object: TipoObrigacao) {
        this._obrigacaoTipoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseTipoObrigacao = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum tipo de obrigação encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._obrigacaoTipoApiService.onGetById(id, onDone);
    }

    private goToList() {
        this._obrigacaoTipoNavigationService.goToList();
    }

    private testSession() {
        var id: number;
        var session: any = this._obrigacaoTipoService.getSessionStorage();
        this._obrigacaoTipoService.clearSessionStorage();

        if (!session) {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(obrigacaoTiposStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.titulo = newAutoComplete.titulo;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._obrigacaoTipoService.returnToOtherForm(this.otherForm, this.responseTipoObrigacao);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/obrigacao-tipo-form/obrigacao-tipo-form.component.ts
 **/